export default "__VITE_ASSET__BBqNXyAA__"